import Candidate from 'types/candidates';
import { RECRUITER } from 'constants/index';
import axiosRequest from './restapi';

export const getUserCandidates = (userRole: string, jobPostId: number, userToken: string) => {
  return axiosRequest(
    {
      method: 'get',
      url: `/${userRole.toLowerCase()}s/${
        userRole === RECRUITER ? 'all-jobs' : 'jobs'
      }/${jobPostId}/candidates`,
    },
    userToken
  );
};

export const getUserCandidate = (userRole: string, candidateId: number, userToken: string) => {
  return axiosRequest(
    {
      method: 'get',
      url: `/${userRole.toLowerCase()}s/candidates/${candidateId}`,
    },
    userToken
  );
};

export const getUserStages = (userRole: string, jobPostId: number, userToken: string) =>
  axiosRequest(
    {
      method: 'get',
      url: `/${userRole.toLowerCase()}s/${
        userRole === RECRUITER ? 'all-jobs' : 'jobs'
      }/${jobPostId}/stages`,
    },
    userToken
  );

export const moveUserCandidate = (
  userRole: string,
  data: {
    jobId: number;
    stageId: number;
    candidateId: number;
  },
  userToken: string
) =>
  axiosRequest(
    {
      method: 'post',
      url: `/${userRole.toLowerCase()}s/candidates/${data.candidateId}/move`,
      data,
    },
    userToken
  );

export const rejectUserCandidate = (
  userRole: string,
  data: {
    jobId: number;
    candidateId: number;
    rejectReason: string;
  },
  userToken: string
) =>
  axiosRequest(
    {
      method: 'post',
      url: `/${userRole.toLowerCase()}s/candidates/${data.candidateId}/reject`,
      data,
    },
    userToken
  );

export const restoreUserCandidate = (userRole: string, candidateId: number, userToken: string) =>
  axiosRequest(
    {
      method: 'post',
      url: `/${userRole.toLowerCase()}s/candidates/${candidateId}/restore`,
    },
    userToken
  );

export const getPendingCandidates = (userToken: string) => {
  return axiosRequest(
    {
      method: 'get',
      url: 'recruiters/candidates?filter={"where": {"status": "pending"}}',
    },
    userToken
  );
};

export const setCandidate = (candidate: Candidate, jobId: string, userToken: string) => {
  return axiosRequest(
    {
      method: 'post',
      url: 'recruiters/candidates',
      data: { candidate, jobId },
    },
    userToken
  );
};

export const getAttachedFile = (url: string, userToken: string) => {
  return axiosRequest(
    {
      method: 'get',
      url,
      responseType: 'blob',
    },
    userToken
  );
};

export const deleteAttachedFile = (url: string, userToken: string) => {
  return axiosRequest(
    {
      method: 'delete',
      url,
    },
    userToken
  );
};

export const setCandidateAttachedFile = (
  userRole: string,
  candidateId: string,
  attachedFileType: string,
  data: any,
  userToken: string
) => {
  return axiosRequest(
    {
      method: 'post',
      url: `/${userRole.toLowerCase()}s/candidates/${candidateId}/${attachedFileType}`,
      data,
    },
    userToken
  );
};

export const setCandidatesCv = (data: any, candidateId: string, userToken: string) => {
  return axiosRequest(
    {
      method: 'post',
      url: `/recruiters/candidates/${candidateId}/cv`,
      data,
    },
    userToken
  );
};

export const setCandidatesCvByLink = (data: any, recruiterId: string, candidateId: string) => {
  return axiosRequest({
    method: 'post',
    url: `/recruiters/${recruiterId}/candidates/${candidateId}/cv`,
    data,
  });
};

export const setCandidateByLink = (
  candidate: any,
  userId: string,
  jobId: string,
  userToken: string
) => {
  return axiosRequest(
    {
      method: 'post',
      url: `/recruiters/${userId}/candidates`,
      data: { candidate, jobId },
    },
    userToken
  );
};

export const setShareLinkByEmail = (link: string, to: string | string[], userToken: string) => {
  return axiosRequest(
    {
      method: 'post',
      url: '/recruiters/send-link',
      data: { link, to },
    },
    userToken
  );
};

export const getCandidateShareLink = (jobId: string, userToken: string) => {
  return axiosRequest(
    {
      method: 'post',
      url: 'recruiters/share-link',
      data: { jobId },
    },
    userToken
  );
};

export const updateCandidate = (candidate: any, userId: string, userToken: string) =>
  axiosRequest(
    {
      method: 'patch',
      url: `/recruiters/candidates/${userId}`,
      data: { candidate },
    },
    userToken
  );

export const deleteCandidate = (userId: string | number, userToken: string) => {
  return axiosRequest(
    {
      method: 'delete',
      url: `/recruiters/candidates/${userId}`,
    },
    userToken
  );
};

export const sendMessages = (note: any, candidateId: string, userToken: string) => {
  return axiosRequest(
    {
      method: 'post',
      url: `/users/candidates/${candidateId}/notifications`,
      data: {
        data: {
          text: note,
        },
      },
    },
    userToken
  );
};

export const getMessages = (userToken: string, filter: any) => {
  return axiosRequest(
    {
      method: 'get',
      url: `/users/notifications?filter=${JSON.stringify(filter)}`,
    },
    userToken
  );
};
